import { Context } from "react"
import OptimizeExperiments from "connected-components/optimize-experiments"
import type { ModelMetadata, OptimizeExperimentsMergedContextValue } from "connected-components/optimize-experiments/types"
import type { SelectedTypedInstrument } from "helpers/types/instruments/selected"

import "./styles.scss"

interface OptimizeExperimentsPanelProps {
  context: Context<OptimizeExperimentsMergedContextValue>
  modelMetadata: ModelMetadata
  isOptimizedExperimentsEnabled: boolean
  optimizationPositionSet: SelectedTypedInstrument | null
  optimizationResultExperimentName: string | null
}

export default function OptimizeExperimentsPanel({
  context,
  modelMetadata,
  isOptimizedExperimentsEnabled,
  optimizationPositionSet,
  optimizationResultExperimentName,
}: OptimizeExperimentsPanelProps) {
  if (!isOptimizedExperimentsEnabled) {
    return null
  }

  return (
    <div className="optimizer-widget-panel visible">
      <OptimizeExperiments
        context={context}
        modelMetadata={modelMetadata}
        optimizationPositionSet={optimizationPositionSet}
        optimizationResultExperimentName={optimizationResultExperimentName}
      />
    </div>
  )
}
